import { buyIdpPath } from '../apps/Themed/ThemedApp.utils';

interface ShouldHideBecomeMemberButtonOptions {
  isMember?: boolean;
  isAuthenticated?: boolean;
}

export function shouldHideBecomeMemberButton(
  currentUrl: string,
  { isMember = false, isAuthenticated = false }: ShouldHideBecomeMemberButtonOptions = {},
): boolean {
  // List of URL substrings that should hide the CTA in the footer.
  const url = currentUrl?.toLowerCase() || '';

  // Check for paths that always hide the CTA
  const alwaysHidePaths = ['bli-medlem', 'velkommen-som-medlem'];
  const hasAlwaysHidePath = alwaysHidePaths.some((path) => url.includes(path));

  // Check for the IDP path - only hide if user is not authenticated
  const isIdpPath = url.includes(buyIdpPath.replace('/', ''));
  const shouldHideOnIdpPath = isIdpPath && !isAuthenticated;

  // Check if the path is exactly '/medlemskap' or '/medlemskap/' (not a longer path like '/medlemskap/medlemsfordeler')
  const isExactMedlemskapPath = url.match(/\/medlemskap\/?(\?|#|$)/) !== null;

  return isMember || hasAlwaysHidePath || shouldHideOnIdpPath || isExactMedlemskapPath;
}
